<h4
  *ngIf="aboveCmpnnt"
  class="alert alert-danger"
  style="position: absolute; top: 30%; left: 0; right: 0"
>
  {{ message }}
</h4>
